/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="79.13"
        height="94.33"
        viewBox="0 0 79.13 94.33"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#0e497b"
          d="M39.56 75.73Z"
          className="icon-fill icon-base"
          fillRule="evenodd"/>
        <path
          fill="#0e497b"
          d="M40.81 63.97v11.75h-2.5V63.97h2.5z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M39.56 64Z"
          className="icon-fill icon-base"
          fillRule="evenodd"/>
        <path
          fill="#0e497b"
          d="M39.56 43.79a1.26 1.26 0 0 1 1.25 1.12V64a1.25 1.25 0 0 1-2.49.12V45a1.25 1.25 0 0 1 1.24-1.21Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M39.56 75.73Z"
          className="icon-fill icon-base"
          fillRule="evenodd"/>
        <path
          fill="#0e497b"
          d="M40.81 63.97v11.75h-2.5V63.97h2.5z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M31.48 75.73Z"
          className="icon-fill icon-base"
          fillRule="evenodd"/>
        <path
          fill="#0e497b"
          d="M32.73 63.97v11.75h-2.5V63.97h2.5zM39.57 0a8.59 8.59 0 1 0 8.59 8.59A8.59 8.59 0 0 0 39.57 0Zm0 2.5a6.09 6.09 0 1 1-6.09 6.09 6.09 6.09 0 0 1 6.09-6.09Z"
          className="icon-fill icon-base"/>
        <path
          fill="none"
          d="M39.56 63.97v11.76"/>
        <path
          fill="#0e497b"
          d="M40.81 63.97v11.75h-2.5V63.97h2.5z"
          className="icon-fill icon-base"/>
        <path
          fill="none"
          d="M39.56 45.04v18.93"/>
        <path
          fill="#0e497b"
          d="M39.56 43.79a1.26 1.26 0 0 1 1.25 1.12V64a1.25 1.25 0 0 1-2.49.12V45a1.25 1.25 0 0 1 1.24-1.21Z"
          className="icon-fill icon-base"/>
        <path
          fill="none"
          d="M39.56 63.97v11.76"/>
        <path
          fill="#0e497b"
          d="M40.81 63.97v11.75h-2.5V63.97h2.5z"
          className="icon-fill icon-base"/>
        <path
          fill="none"
          d="M31.48 63.97v11.76"/>
        <path
          fill="#0e497b"
          d="M32.73 63.97v11.75h-2.5V63.97h2.5z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M64.88 10.11a4.28 4.28 0 0 1 2.75 7.57l-.19.16L48.9 30.65V64a1.25 1.25 0 0 1-1.12 1.24h-.13a1.26 1.26 0 0 1-1.25-1.14V30a1.27 1.27 0 0 1 .43-1l.11-.08 19-13.15a1.79 1.79 0 0 0-1.09-3.21 1.85 1.85 0 0 0-.74.15l-.17.09-15.7 9a1.23 1.23 0 0 1-.49.16H31.48a1.25 1.25 0 0 1-.51-.1l-.11-.06-15.71-9a1.73 1.73 0 0 0-.9-.24 1.79 1.79 0 0 0-1.79 1.79 1.77 1.77 0 0 0 .54 1.33l.12.1L32.19 29a1.23 1.23 0 0 1 .53.89V64a1.25 1.25 0 0 1-2.49.13V30.65L11.63 17.8A4.27 4.27 0 0 1 10 14.64v-.24a4.29 4.29 0 0 1 4.29-4.29 4.25 4.25 0 0 1 1.93.45l.22.12 15.41 8.86h15.5l15.41-8.85a4.18 4.18 0 0 1 1.9-.58Z"
          className="icon-fill icon-base"/>
        <path
          fill="none"
          d="M47.65 63.97v11.76"/><path
          fill="#0e497b"
          d="M48.9 63.97v11.75h-2.5V63.97h2.5z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M26.79 81v2.5H2.5v10.85H0v-12.1A1.24 1.24 0 0 1 1.12 81h25.67ZM77.88 86.14a1.25 1.25 0 0 1 1.24 1.12v7.07h-2.5v-5.69H52.33v-2.5Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M52.33 74.09a1.26 1.26 0 0 1 1.25 1.12v19.12h-2.5V76.59H28v17.74h-2.5v-19a1.26 1.26 0 0 1 1.12-1.25h25.71Z"
          className="icon-fill icon-accent"/>
      </svg>

    );
  }
}

Icon.displayName = 'OnePersonOnChampionshipPodiumFirstPlaceIcon';

export default Icon;
